<template>
  <ElDialog
    :title="$t('AUTH.STEPS.IDENTITY_VERIFICATION.EDIT_PHONE_MODAL_TITLE')"
    :visible="value"
    width="35%"
    @close="emitInputValue"
  >
    <ElForm
      ref="editPhoneModel"
      :model="editPhoneModel"
      :rules="editPhoneRules"
      label-position="top"
      @submit.native.prevent="changePhoneNumber"
    >
      <ElFormItem :label="$t('MOBILE_PHONE')" prop="phone" required>
        <ElInput
          v-model="editPhoneModel.phone"
          type="tel"
          dir="ltr"
          name="phone"
          placeholder="09"
          :maxlength="11"
        />
        <p class="el-form-item__help">
          <i class="el-icon-warning" />
          {{ $t('AUTH.STEPS.CELLPHONE_WARNING') }}
        </p>
      </ElFormItem>

      <div>
        <ElButton type="default" @click.native="emitInputValue">
          {{ $t('AUTH.STEPS.IDENTITY_VERIFICATION.CANCEL_EDIT_PHONE_BTN') }}
        </ElButton>
        <ElButton type="primary" native-type="submit" :loading="loading">
          {{ $t('AUTH.STEPS.IDENTITY_VERIFICATION.EDIT_PHONE_BTN') }}
        </ElButton>
      </div>
    </ElForm>
  </ElDialog>
</template>

<script>
import form from '@/mixins/form';
import normalizeNumbers from '@/utils/normalizeNumbers';

export default {
  name: 'ChangePhoneNumberModal',
  mixins: [form],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editPhoneModel: {
        phone: this.phone,
      },
    };
  },
  computed: {
    editPhoneRules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('VALIDATION_REQUIRED_ERR'),
            trigger: ['blur', 'change'],
          },
          {
            pattern: /^09\d{9}$/i,
            message: this.$t('PUBLISHER_ACCOUNT.INVALID_PHONE'),
          },
        ],
      };
    },
  },
  watch: {
    phone() {
      this.editPhoneModel.phone = this.phone;
    },
    editPhoneModel: {
      deep: true,
      handler: normalizeNumbers,
    },
  },
  methods: {
    emitInputValue() {
      this.$emit('input', false);
    },
    changePhoneNumber() {
      const { phone } = this.editPhoneModel;
      if (this.phone === phone) {
        this.emitInputValue();
        return;
      }

      if (!this.isValid('editPhoneModel')) {
        return false;
      }
      this.$emit('changePhone', phone);
    },
  },
};
</script>
